export const StatusColorNames = {
  Gray: 'Gray',
  Yellow: 'Yellow',
  Green: 'Green',
  Red: 'Red',
}

export const StatusColors = {
  [StatusColorNames.Gray]: { hex: '#ccc', filter: 'invert(70%) sepia(97%) saturate(1%) hue-rotate(334deg) brightness(96%) contrast(94%)' },
  [StatusColorNames.Yellow]: { hex: '#ffcc00', filter: 'invert(76%) sepia(96%) saturate(2614%) hue-rotate(359deg) brightness(102%) contrast(103%)' },
  [StatusColorNames.Green]: { hex: '#0a0', filter: 'invert(45%) sepia(75%) saturate(6428%) hue-rotate(113deg) brightness(106%) contrast(108%)' },
  [StatusColorNames.Red]: { hex: '#f00', filter: 'invert(18%) sepia(98%) saturate(7327%) hue-rotate(356deg) brightness(93%) contrast(118%)' },
}

export const getFilterColor = (filterObj, filterName) => {
  // console.log(filterObj, filterName);
  const filtervalue = filterObj && filterObj.bpFilter && filterObj.bpFilter[filterName];

  if (filtervalue && filtervalue !== StatusColorNames.Gray) {
    return StatusColors[filtervalue]['hex'];
  } else {
    return '';
  }
}

export const getBPFilterDict = () => Object.assign({}, {
  status_c: [ StatusColorNames.Gray, StatusColorNames.Yellow, StatusColorNames.Green, StatusColorNames.Red ],
  status_r: [ StatusColorNames.Gray, StatusColorNames.Yellow, StatusColorNames.Green, StatusColorNames.Red ],
  status_l: [ StatusColorNames.Gray, StatusColorNames.Green, StatusColorNames.Red ],
  status_t: [ StatusColorNames.Gray, StatusColorNames.Green, StatusColorNames.Red ],
  status_i: [ StatusColorNames.Gray, StatusColorNames.Yellow, StatusColorNames.Green, StatusColorNames.Red ],
  status_exclusivity: [ StatusColorNames.Gray, StatusColorNames.Green, StatusColorNames.Red ]
});

export const cycleBPFilter = (filterName, filterObj, filterDict = getBPFilterDict()) => {
  const filterOptions = filterDict[filterName];
  const oldFilter = filterObj[filterName];
  const oldIndex = filterOptions.findIndex(e => e === oldFilter);
  const newIndex = oldIndex >= filterOptions.length -1
    ? 0
    : oldIndex + 1;
  const newFilter = filterOptions[newIndex];
  console.log("WERETYU",{
    oldFilter,
    newFilter
  });
  return {
    ...filterObj,
    [filterName]: newFilter
  }
}

export const getDefaultBPFilter = () => Object.assign({}, {
  status_c: StatusColorNames.Gray,
  status_r: StatusColorNames.Gray,
  status_l: StatusColorNames.Gray,
  status_t: StatusColorNames.Gray,
  status_i: StatusColorNames.Gray,
  status_exclusivity: StatusColorNames.Gray,
});